import React from 'react';
import { Flex, Typography, Image, Divider, Tag, Space } from 'antd';


const { Title, Paragraph, Text } = Typography;
const boxStyle = {
    width: '100%',
    height: 100,
    margin: '0 auto',
    // backgroundColor: '#ddf9dc',
    // borderBottom: ' 1px solid #40a9ff',
};
const cardStyle = {
    fontSize: '1.2em',
    color: '#595959',
    paddingTop: '18px',
};


const Foot = () => {

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >


            <Space orientation="vertical"  >
                <Flex style={boxStyle} gap='large' justify='center' align='flex-start' horizontal="true" >


                    <div>
                        <Typography >
                            <Title level={5} type="secondary" >郑州胜聪电子科技有限公司</Title>

                            <Text type="secondary" >
                                地址：郑州市长椿路冬青街河南省电子商务产业园
                            </Text>
                            <Paragraph type="secondary" >
                                邮箱：sys@ddspp.com 电话： 0371 -6094 6116
                            </Paragraph>

                        </Typography>

                    </div>


                    <div size="small" style={cardStyle}>
                        <Typography>

                            <Paragraph >
                                <Tag color="processing"> 防伪溯源</Tag>
                                <Tag color="processing"> 产品全生命周期管理</Tag>
                                <Tag color="processing"> 农药二维码系统</Tag>
                                <Tag color="processing"> 化肥二维码系统</Tag>
                                <Tag color="processing"> 种子二维码系统</Tag>

                            </Paragraph>

                            <Paragraph >

                                <Tag color="cyan">备货管理系统</Tag>
                                <Tag color="cyan">仓库管理系统</Tag>
                                <Tag color="cyan">配货辅助系统</Tag>
                                <Tag color="cyan">资产管理维保系统</Tag>
                                <Tag color="cyan">先进先出保质期管理辅助</Tag>
                            </Paragraph>

                            <Paragraph >
                                <Tag color="success"> 活动营销管理</Tag>
                                <Tag color="success"> 积分兑换</Tag>
                                <Tag color="success"> 大转盘抽红包</Tag>
                                <Tag color="purple"> 产线采集关联管理</Tag>
                                <Tag color="purple"> 工艺防呆</Tag>
                                <Tag color="magenta"> 高拍仪</Tag>
                                <Tag color="magenta"> 便携PDA</Tag>

                            </Paragraph>





                        </Typography>
                    </div>





                    <div size="small" style={cardStyle}>
                        <Typography style={{ marginTop: '17px' }}>
                            <Image
                                width={218}
                                src="https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1765642825#sc"
                            // preview={false}
                            />
                        </Typography>
                    </div>


                </Flex>

                <Divider
                    plain
                    style={{
                        borderColor: '#7cb305',
                    }}
                >
                    <Text type="secondary" >胜聪网@2025-2027 ddspp.com  <a target='blank' href='https://beian.miit.gov.cn/' style={{ color: '#383838', textdecoration: "none" }} ><Text type="secondary" >豫ICP备13017074号</Text></a></Text>
                </Divider>

            </Space>

        </div>

    );
};
export default Foot;
